module.exports = __webpack_public_path__ + "img/go2-dashboard.8b94d94d.png";